"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

require("whatwg-fetch");

var _url = require("../utils/url");

var _authService = require("./authService");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// import pickBy from 'lodash.pickby';
function _default(auth) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location.origin;

  // TODO - refactor these arguments to be a single hash, this is silly
  var APICall = function APICall(endpoint) {
    var _this = this;

    var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
    var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var query = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var bypassToken = options.bypassToken;
    var args = arguments;

    var retry = function retry() {
      return APICall.apply(_this, args);
    };

    var parseResponse = function parseResponse(r) {
      var contentType = r.headers.get('content-type');

      if (contentType && contentType.indexOf('application/json') === 0) {
        var fallback = r.clone();
        return r.json().catch(function (err) {
          return fallback.text().then(function (body) {
            // if the parsing error was just because the response was empty, ignore the error and return empty string
            if (body === '') {
              return body;
            } // else it's a real error, throw it


            throw Error(err);
          });
        });
      }

      return r.text();
    };

    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': "Bearer ".concat(auth.getToken())
    };
    var idToken = auth.getToken(_authService.ID_TOKEN_KEY);

    if (idToken) {
      headers['X-ID-Token'] = idToken;
    }

    var origin = /^http/.test(endpoint) ? '' : base;
    return fetch("".concat(origin).concat(endpoint).concat((0, _url.toQueryString)(query)), {
      method: method,
      headers: headers,
      body: body ? JSON.stringify(body) : undefined
    }) // pass down a boolean indicating if the response is ok, as well as the parsed response
    .then(function (response) {
      return Promise.all([new Promise(function (resolve) {
        return resolve(response.ok);
      }), parseResponse(response)]);
    }).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          ok = _ref2[0],
          body = _ref2[1];

      if (ok) {
        return body;
      } else {
        throw body;
      }
    }).catch(function (err) {
      console.error(err);

      try {
        // jwt is malformed or not found, just logout
        if (err && err.status === 401 && err.message.match(/malformed|not found/ig)) {
          if (typeof auth.logoutWithReentry === 'function') {
            auth.logoutWithReentry();
            return;
          }
        } // if we get a 401 with an expired message, then our token could be expired, so try to refresh it and retry


        if (err && err.status === 401 && (err.message && /expired/ig.test(err.message) || err.body && /expired/ig.test(JSON.stringify(err.body)))) {
          if (auth.isImpersonated()) {
            auth.logout({
              impersonated: true
            });
            return;
          }

          return auth.renewAuth().then(retry).catch(function (err) {
            console.error(err);
            return auth.logoutWithReentry();
          });
        }
      } catch (_) {}

      throw err;
    });
  };

  return APICall;
}